// extracted by mini-css-extract-plugin
export var printerCard = "_ar-1";
export var printerCardConfigured = "_ar-2";
export var printerCardError = "_ar-3";
export var printerCardsContainer = "_ar-0";
export var printerIcon = "_ar-8";
export var printerIconConfigured = "_ar-5";
export var printerIconContainer = "_ar-4";
export var printerIconError = "_ar-6";
export var printerIconUnconfigured = "_ar-7";